import { Route } from 'src/routes/Route'

export const InvitesRoute = Route({ path: '/invites' })
export type InvitesRoute = Route<typeof InvitesRoute>
